<template>
	<div class="rank-table">
	  <div class="table-tr flex-center-between" v-for="(item, i) in bitDataList" :key="i" >
			<div class="flex-3 flex-center-start">
				<div class="icon" :class="item.ShortName == 'BAL' ? 'bg' : ''">
					<img :src="`/upload/${item.Logo}`" alt="">
				</div>
				<div class="name">
					{{item.ShortName}}<span class="gray">/USDT</span>
				</div>
			</div>
			<div class="flex-2 text-center ">${{item.count}}</div>
			<div class="flex-2 text-center " >
				<div class="percent" :class="!item.percent || item.percent >= 0 ? 'green' : 'red'">
					{{item.percent && item.percent > 0 ? '+' : ''}}{{item.percent !== undefined ? `${item.percent}%` : '--'}}
				</div>
			</div>
      <div class="flex-3 text-center count">
        <lineChart :id="`line-chart${i + (pageSpace ? pageSpace : 0)}`" :color="item.percent >= 0 ? 'green' : 'red'"></lineChart>
      </div>
      <div class="action text-center " @click="chooseBit(item)">{{ $t('jiao-yi') }}</div>
		</div>
	</div>
</template>
<script>
import lineChart from './lineChart.vue'
export default {
  components: {
    lineChart
  },
	data() {
		return {
			bitDataList: []
		}
	},
	props: {
		dataList: Array,
		subscribe: Boolean,
		pageSpace: Number
	},
	computed: {
  },
	watch: {
		dataList(val) {
			if (val) {
				this.bitDataList = this.dataList.filter(v => {
					return v.ShortName != 'USDT'
				})
			}
		}
	},
	mounted() {
		this.bitDataList = this.dataList.filter(v => {
			return v.ShortName != 'USDT' || v.ShortName != "WBTC"
		})
	},
	methods: {
   
		chooseBit(data) {
			this.$emit('detail', data)
		}
	}
}
</script>